import { Box, Typography, Button } from '@mui/material';
import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material';

type Props = {
  icon: ComponentType<SvgIconProps>;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
};

const EmptyState = ({ icon: Icon, title, description, actionLabel, onAction }: Props) => (
  <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
    <Box
      sx={{
        width: 76, height: 76, mx: 'auto', mb: 2, borderRadius: '26px', display: 'grid', placeItems: 'center',
        color: '#fff',
        background: 'linear-gradient(135deg, #6226A7, #B13FD6 60%, #F6A938)',
        boxShadow: '0 14px 28px rgba(98,38,167,.35), inset 0 1px 0 rgba(255,255,255,.5)',
        transform: 'rotate(-6deg)',
      }}
    >
      <Icon sx={{ fontSize: 38 }} />
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: actionLabel ? 2 : 0 }}>
        {description}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="contained" onClick={onAction} sx={{ mt: 1 }}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
